import { render, staticRenderFns } from "./OrderPendingList.vue?vue&type=template&id=4a544d0d"
import script from "./OrderPendingList.js?vue&type=script&lang=js&external"
export * from "./OrderPendingList.js?vue&type=script&lang=js&external"
import style0 from "./OrderPendingList.vue?vue&type=style&index=0&id=4a544d0d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports